<template>
  <div v-if="answerItem.Music">
    <answer-portrait :h5ConfigData="h5ConfigData"></answer-portrait>
    <div class="answer-content audio-wrap" :class="{ answerContentSjtu: owner === 'SJTU' }" @click="handleAudio">
        <i v-if="answerItem.Music !== curAudioSrc || (answerItem.Music === curAudioSrc && ifPause)" class="iconfont icon-ecard-voice"></i>
        <img v-if="answerItem.Music === curAudioSrc && !ifPause" src="~@/app/assets/imgs/voice-gray.gif" alt />
    </div>
  </div>
</template>

<script>
import AnswerPortrait from './AnswerPortrait.vue'

export default {
  props: {
    h5ConfigData: {
      type: Object
    },

    answerItem: {
      type: Object
    },

    curAudioSrc: {
      type: String
    },

    owner: String
  },

  components: {
    AnswerPortrait
  },

  data () {
    return {
      ifPause: false
    }
  },

  watch: {
    curAudioSrc () {
      if (this.answerItem.Music !== this.curAudioSrc) {
        this.ifPause = false
      }
    }
  },

  methods: {
    handleAudio () {
      if (this.answerItem.Music === this.curAudioSrc) {
        this.ifPause = !this.ifPause
      }
      this.$emit('setCurAudioSrc', 'answer', this.answerItem.Music)
    }
  }
}
</script>

<style lang="scss" scoped>
.answer {
    &-content {
        position: relative;
        max-width: 560px;
        padding: 20px 24px;
        line-height: 44px;
        font-size: 32px; /*px*/
        word-break: break-all;
        word-wrap: word-break;
        color: #111e2e;
        background: #ffffff;
        box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.02);
        border-radius: 12px;

        &.audio-wrap {
            display: flex;
            align-items: center;
            width: 144px;
            user-select: none;

            .iconfont {
                font-size: 36px; /*px*/
                color: #606266;
                transform: rotate(180deg);
            }

            img {
                width: 40px;
            }
        }
    }
}
.answerContentSjtu {
    background: #f3f4f6;
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/app/GenH5/Answer/AnswerMusic.vue